import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SaleAction } from '../../store/actions';

class RegistrationApplication extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  render() {
    return (
      <div>
        <div>
          <div className="row">
            <div className="col-12 text-center">
              FORM OF APPLICATION FOR THE REGISTRATION OF MOTOR VEHICLE
            </div>
            <div className="col-12 text-center">
              To be filled in by the office
            </div>
            <div className="col-12 text-center">
              Section-I
            </div>
            <div className="col-4">
              Regn No.:
            </div>
            <div className="col-4">
              Date:
            </div>
            <div className="col-4">
              Prev. Regn. No. (If any):
            </div>
            <div className="col-4">
              Issue No.:
            </div>
            <div className="col-4">
              Date:
            </div>
            <div className="col-4">
              Issue by:
            </div>
            <div className="col-4">
              Diary No.:
            </div>
            <div className="col-4">
              Date:
            </div>
            <div className="col-4">
              Received by:
            </div>
            <div className="col-4">
              Customer ID:
            </div>
            <div className="col-4">
              District:
            </div>
            <div className="col-4">
              Vehicle ID:
            </div>
            <div className="col-4">
              Veh. Description:
            </div>
            <div className="col-4 offset-4">
              Call non date:
            </div>
            <div className="col-4">
              Refusal date:
            </div>
            <div className="col-4">
              Refusal Code:
            </div>
            <div className="col-4">
              Refused by:
            </div>
            <div className="col-4">
              P.O./Bank:
            </div>
            <div className="col-4 offset-4">
              Index:
            </div>
            <div className="col-4">
              Remarks (if any):
            </div>
            <div className="col-4 offset-4">
              Index No.:
            </div>
            <div className="col-12 text-center">
              To be filled in by the Owner
            </div>
            <div className="col-12 text-center">
              Section II
            </div>
            <div className="col-12 text-center">
              (Owner information)
            </div>
            <div className="col-6">
              1. Name of owner:
            </div>
            <div className="col-6">
              2. Date of birth:
            </div>
            <div className="col-6">
              3. Father/Husband:
            </div>
            <div className="col-6">
              4. Nationality:
            </div>
            <div className="col-6">
              5. Sex:
            </div>
            <div className="col-6">
              6. Guardian’s name:
            </div>
            <div className="col-12">
              7. Owner’s Address (One only):
            </div>
            <div className="col-6">
              8. Phone No. (if any):
            </div>
            <div className="col-6">
              9. P.O./Bank:
            </div>
            <div className="col-6">
              10.  Joint owner:
            </div>
            <div className="col-6">
              11. Owner type:
            </div>
            <div className="col-6">
              12. Hire:
            </div>
            <div className="col-6">
              13. Hire purchase:
            </div>
            <div className="col-12 text-center">
              To be filled in by the Owner
            </div>
            <div className="col-12 text-center">
              Section III
            </div>
            <div className="col-12 text-center">
              (Owner information)
            </div>
            <div className="col-6">
              14. Vehicle or trailer:
            </div>
            <div className="col-6">
              15. Prev. Regn. No. (if any):
            </div>
            <div className="col-6">
              14a. Class of vehicle:
            </div>
            <div className="col-6">
              15a. Maker’s name:
            </div>
            <div className="col-6">
              16. Type of body:
            </div>
            <div className="col-6">
              17. Maker’s Country:
            </div>
            <div className="col-6">
              18. Color (cabin/body):
            </div>
            <div className="col-6">
              19. Year of manufacture:
            </div>
            <div className="col-6">
              20. Number of cylinders:
            </div>
            <div className="col-6">
              21. Chassis number:
            </div>
            <div className="col-6">
              22. Engine number:
            </div>
            <div className="col-6">
              23. Fuel used:
            </div>
            <div className="col-6">
              24. Horse power:
            </div>
            <div className="col-6">
              25. RPM:
            </div>
            <div className="col-6">
              26. Cubic capacity:
            </div>
            <div className="col-6">
              27. Seats (incl. driver):
            </div>
            <div className="col-6">
              28. No. of Standee:
            </div>
            <div className="col-6">
              29. Wheel base:
            </div>
            <div className="col-6">
              30. Unladen weight (kg):
            </div>
            <div className="col-6">
              31. Maximum laden/train weight (kg):
            </div>
            <div className="col-12 text-center">
              Section IV
            </div>
            <div className="col-12 text-center">
              (Additional information for transport vehicle)
            </div>
            <div className="col-6">
              32. No. of types:
            </div>
            <div className="col-6">
              33. Tyres size:
            </div>
            <div className="col-6">
              34. No. of axle:
            </div>
            <div className="col-6">
              35. Maximum axle weight (kg):
              <div>
                a) Front axle (1) (2)
              </div>
              <div>
                b) Central axle (1) (2) (3)
              </div>
              <div>
                c) Rear axle (1) (2) (3)
              </div>
            </div>
            <div className="col-12">
              36. Dimensions (mm):
              <div>
                a) Overall length b) Overall width c)
                Overall height
              </div>
            </div>
            <div className="col-12">
              37. Overhangs (%)
              <div>
                a) Front b) Rear c) Other
              </div>
            </div>
            <div className="col-12">
              38. A copy of the drawing showing the vehicle dimension specifications of the body and of the seating
              <div>
                arrangements approved by .................... on .................... is attached herewith.
              </div>
            </div>
            <div className="col-12 text-right">
              Page 1 of 3
            </div>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-12 text-center">
              Section V
            </div>
            <div className="col-12">
              39. Hire purchase/hypothecation information:
              <div>
                The vehicle is subject to hire purchase/hypothecation with:
              </div>
              <div className="row">
                <div className="col-6">
                  a)  Name:
                  <div>
                    Address:
                  </div>
                </div>
                <div className="col-6">
                  b) Date:
                </div>
              </div>
            </div>
            <div className="col-12">
              40. Insurance information:
              <div className="row">
                <div className="col-4">
                  a) Policy no:
                </div>
                <div className="col-4">
                  b) Type of policy:
                </div>
                <div className="col-4">
                  c) Insurer’s name &amp; address:
                </div>
                <div className="col-4">
                  d)  Date of expiry:
                </div>
              </div>
            </div>
            <div className="col-12">
              41. Joint owner information:
              <div className="row">
                <div className="col-6">
                  a) Name:
                  <div>
                    Father/Husband:
                  </div>
                </div>
                <div className="col-6">
                  b) Name:
                  <div>
                    Father/Husband:
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center">
              Section VI
            </div>
            <div className="col-12 text-center">
              (Declaration, Certificates and documents)
            </div>
            <div className="col-12">
              42. Declaration by owner:
              <div>
                a) I the undersigned do hereby declare that to the best of my knowledge and belief, the information given and the documents enclosed (as per list attached) are true. I also declare that in case the papers/documents and information furnished are found to be incorrect at any later stage, I shall be liable for legal action.
              </div>
            </div>
            <div className="col-6">
              Date:
            </div>
            <div className="col-6 text-right">
              Signature of owner
              <div>
                Seal
              </div>
            </div>
            <div className="col-12">
              Encl: List of documents
            </div>
            <div>
              43. Registered dealer’s certificate:
              <div>
                I the undersigned do hereby certify that the vehicle in question has been sold by me/my firm and the ownership documents attached with the application for registration are true. The information/specifications pertaining to the vehicle are correct and the vehicle complies with all the requirements of the registration.
              </div>
            </div>
            <div className="col-6">
              Date:
            </div>
            <div className="col-6 text-right">
              Signature of owner
              <div>
                Seal
              </div>
            </div>
            <div className="col-12">
              Encl: List of documents
            </div>
            <div>
              44. certificate by the Inspector of Motor Vehicles:
              <div>
                Certificate that the particulars pertaining to the owner and the vehicle (Chassis No. .................... Engine No ....................) given in the application match with the ownership documents attached to this application. It is further certified that the vehicle complies with the registration requirements specified in the MV Act and the Rules and/or Regulations made thereunder and the vehicle is not mechanically defective. The necessary documents/papers are available as per list enclosed.
              </div>
            </div>
            <div className="col-6">
              Date:
            </div>
            <div className="col-6 text-right">
              Signature of Inspector of Motor Vehicles
              <div>
                Official Seal
              </div>
            </div>
            <div className="col-12">
              Encl: List of documents
            </div>
            <div className="col-12">
              45. Registration Status:
              <div className="row">
                <div className="col-6">
                  Registration allowed/not allowed
                </div>
                <div className="col-6 text-right">
                  Signature of Registering Authority
                  <div>
                    Seal
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              46. Fees and Tax Accounts:
              <div>
                Necessary fees and taxes amounting to taka .................... has been paid to PO/Bank .................... vide vouchers and receipts enclosed.
              </div>
              <div className="row">
                <div className="col-6">
                  Signature of owner of his representative
                </div>
                <div className="col-6 text-right">
                  Signature of dealing assistant
                </div>
              </div>
            </div>
            <div className="col-12 text-center">
              Counter signature by the registering authority.
            </div>
            <div className="col-12 text-right">
              Page 2 of 3
            </div>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-12 text-center">
              OWNER’S PARTICULARS/SPECIMEN SIGNATURE
            </div>
            <div className="col-12 text-right">
              <div className="border border-dark d-inline-block">
                3 Copies Photograph
                <br />
                Stamp Size
                <br />
                Color Pic
              </div>
            </div>
            <div className="col-12">
              1. NAME:
            </div>
            <div className="col-12">
              2. FATHER/HUSBAND:
            </div>
            <div className="col-12">
              3. ADDRESS:
            </div>
            <div className="col-12">
              4. SEX:
            </div>
            <div className="col-12">
              5. PHONE NO:
            </div>
            <div className="col-12">
              6. NATIONALITY:
            </div>
            <div className="col-12">
              7. DATE OF BIRTH:
            </div>
            <div className="col-12">
              8. GUARDIAN’S NAME:
            </div>
            <div className="col-12">
              9. CHASSIS NO:
            </div>
            <div className="col-12">
              10. ENGINE NO:
            </div>
            <div className="col-12">
              11. YEAR OF MFG:
            </div>
            <div className="col-12">
              12. PREV. REGN. NO. (IF ANY):
            </div>
            <div className="col-12">
              13. P.O./BANK:
            </div>
            <div className="col-12">
              <u>
                SPECIMEN SIGNATURE
              </u>
            </div>
            <div className="col-6">
              1.
            </div>
            <div className="col-6">
              2.
            </div>
            <div className="col-6">
              3.
            </div>
            <div className="col-6">
              4.
            </div>
            <div className="col-12 text-right">
              Page 3 of 3
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationApplication);
